import styled, { css } from "styled-components";



export const Label = styled.label`
    font-size: 14px;
    font-family: var(--FinanceLabelFont-family);
    text-align: start;
    font-weight: 500;
    margin-top: 20px;

`
export const Wrapper = styled.div`
      background-color: rgb(231, 237, 249);
    width: max-content;
    border-radius: 4px;
    margin-bottom: 41px;
    margin-top:10px;

`
export const ButtonGroup = styled.div`
    background: #f3f6f9;
    border: 1px solid #2555ef;
    box-sizing: border-box;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height:50px;
    cursor: pointer;
    grid-gap: 1px;
    gap: 1px;

`

export const TaxButton = styled.button`
`
export const StatementButton = styled.button`
   height: 28px;
     color: #2555EF;
    ${(props) => (props?.isClicked === 'tax_statement' &&
        css`
            color:#FFFFFF; height: 28px;
            `
    )};
`

export const Content = styled.div`
width: 100%;
`

export const StatementWrapper = styled.div`
overflow-x: hidden;
overflow:hidden
`
export const Button = styled.div`
display: flex;
justify-content: center;
`
export const CreateButton = styled.button`

    width: 271px ;
    margin-top: 5px ;
    height: 48px ;
    background-color:#2555ef;
    color:#ffff;
    font-weight: bold;
    border-radius: 5px;
    font-size: 14px;
    ${(props) => (props?.isLoading &&
        css`
        background-color:gray;
            `
    )}; 
`

export const TextAreaMessage = styled.textarea`
    width: 100%;
    font-family: var(--FinanceTextAreaMessageFont-family);
    border-radius: 4px;
    height: 100px;
    padding: 12px 20px;
    background-color: rgb(243, 246, 249);
    border: none;
    resize: none;
    color:#002E5C;
`
